import React, { useEffect, useState } from 'react';
import { Button, Input } from 'tea-component';
import classnames from 'classnames';
import './index.scss';
interface IPropsRenameBox {
  value: string;
  handleOnChangeRenameValue: (...args: any[]) => void;
  handleChangeModalCancel?: (...args: any[]) => void;
}
export default function RenameBox(props: Partial<IPropsRenameBox>) {
  const { value, handleOnChangeRenameValue, handleChangeModalCancel } = props;
  const [inputValue, setInputValue] = useState(value);

  return (
    <div className={classnames('dialog-rename-box dbg-rename-box')}>
      <div className="dialog-rename-box-hd">
        <h3 className="dialog-rename-box-title">Rename</h3>
        <Button icon="close" onClick={handleChangeModalCancel} />
      </div>
      <div className="dialog-rename-body">
        <Input
          value={inputValue}
          className="dialog-rename-text"
          onChange={(text) => setInputValue(text)}
          placeholder={'Please input file name'}
        />
      </div>
      <div className="dialog-rename-footer">
        <Button
          type="primary"
          onClick={() => {
            handleOnChangeRenameValue?.(inputValue);
            handleChangeModalCancel?.();
          }}
          disabled={inputValue === ''}
        >
          Confirm
        </Button>
        <Button type="weak" onClick={handleChangeModalCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
